module.exports = __webpack_public_path__ + "static/media/WMASS-BUSD.5f9d56da.svg";